import { useEffect, useState } from "react";

export const VideoDuration = ({ url }) => {
    const [duration, setDuration] = useState("");

    useEffect(() => {
        const video = document.createElement("video");

        video.src = url;

        video.onloadedmetadata = () => {
            const totalSeconds = Math.floor(video.duration);

            const mins = Math.floor(totalSeconds / 60);
            const secs = totalSeconds % 60;

            setDuration(`${mins}m ${secs}s`);
        };
    }, [url]);

    return (
        <span className="text-[11px] bg-gray-100 px-2 py-[2px] rounded whitespace-nowrap">
            {duration}
        </span>
    );
};